/**
 * Рассчитывает координаты карточки относительно окна браузера
 * @param {HTMLElement} markerEl
 * @param {HTMLElement} balloonEl
 * @returns {{x: number, y: number}}
 */
export function getBalloonPosition(markerEl, balloonEl) {
  if (!markerEl || !balloonEl) return { x: 0, y: 0 };

  const markerRect = markerEl.getBoundingClientRect();
  const balloonRect = balloonEl.getBoundingClientRect();

  const GAP = 10; // отступ между маркером и карточкой
  const PADDING = 8; // минимальный отступ от краев экрана

  const markerCenterX = markerRect.left + markerRect.width / 2;
  let x = markerCenterX - balloonRect.width / 2;

  // Не даем выйти за экран
  if (x < PADDING) {
    x = PADDING;
  } else if (x + balloonRect.width > window.innerWidth - PADDING) {
    x = window.innerWidth - balloonRect.width - PADDING;
  }

  const asideFilter = document.querySelector('.aside-fixed');

  if (asideFilter) {
    const asideRect = asideFilter.getBoundingClientRect();

    const balloonLeft = x;
    const balloonRight = x + balloonRect.width;

    const intersectsAside = balloonLeft < asideRect.right && balloonRight > asideRect.left;

    if (intersectsAside) {
      x = asideRect.right + GAP;
    }
  }

  const spaceAbove = markerRect.top;
  const spaceBelow = window.innerHeight - markerRect.bottom;

  let y;

  // Если сверху помещается
  if (spaceAbove >= balloonRect.height + GAP + PADDING) {
    // Рисуем над маркером
    y = markerRect.top - balloonRect.height - GAP;
  }
  // Иначе, если снизу помещается
  else if (spaceBelow >= balloonRect.height + GAP + PADDING) {
    // Рисуем под маркером
    y = markerRect.bottom + GAP;
  } else {
    y = Math.max(PADDING, Math.min(markerRect.bottom + GAP, window.innerHeight - balloonRect.height - PADDING));
  }

  return { x, y };
}
